<template>
  <div>
    <template v-if="getId">
      <main-request-form />
    </template>
    <template v-else>
      <new-request-form />
    </template>
  </div>
</template>

<script>
import NewRequestForm from './components/NewRequestForm.vue'
import MainRequestForm from './components/MainRequestForm.vue'
export default {
  name: 'PreparedSentMessageForm',
  components: {
    NewRequestForm,
    MainRequestForm,
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
  },
}
</script>

<style>
</style>